import React from 'react';

export const Skeleton = ({ w = '100%', h = 12, className = '', style = {} }) => (
  <span className={`sk ${className}`} style={{ '--sk-w': w, '--sk-h': typeof h === 'number' ? `${h}px` : h, ...style }} />
);

export const SkeletonCircle = ({ size = 72, className = '', style = {} }) => (
  <span className={`sk sk--circle ${className}`} style={{ '--sk-size': typeof size === 'number' ? `${size}px` : size, ...style }} />
);

export const SkeletonPill = ({ w = 72, h = 28, className = '', style = {} }) => (
  <span className={`sk sk--pill ${className}`} style={{
    '--sk-w': typeof w === 'number' ? `${w}px` : w,
    '--sk-h': typeof h === 'number' ? `${h}px` : h, ...style }} />
);

export const SkeletonDonut = ({ size = 180, className = '', style = {} }) => (
  <span className={`sk sk--donut ${className}`} style={{ '--sk-size': typeof size === 'number' ? `${size}px` : size, ...style }} />
);

export const SkeletonBar = ({ w = '100%', h = 8, className = '', style = {} }) => (
  <span className={`sk ${className}`} style={{ '--sk-w': w, '--sk-h': typeof h === 'number' ? `${h}px` : h, borderRadius: '9999px', ...style }} />
);

/* Ready-made stacks for common cards */
export const SkeletonStatCard = () => (
  <div className="card custom-card mb-3 sk-card">
    <div className="card-body">
      <Skeleton className="sk-title" />
      <div className="sk-row" style={{ marginTop: '12px' }}>
        <SkeletonCircle size={28} />
        <Skeleton w="50%" h={24} />
      </div>
      <SkeletonBar />
      <Skeleton w="22%" h={14} style={{ float: 'right', marginTop: '8px' }} />
    </div>
  </div>
);

export const SkeletonMetricCard = () => (
  <div className="card custom-card mb-3 sk-card">
    <div className="card-body text-center py-2 sk-stack">
      <SkeletonCircle size={72} />
      <Skeleton w="140px" h={14} />
      <Skeleton w="160px" h={28} />
    </div>
  </div>
);

export const SkeletonAreaChartCard = () => (
  <div className="card custom-card overflow-hidden sk-card">
    <div className="card-body">
      <Skeleton w="200px" h={16} />
      <Skeleton w="260px" h={12} style={{ marginTop: '8px' }} />
      <div className="sk-row" style={{ marginTop: '8px' }}>
        <SkeletonPill w={72} h={28} />
        <SkeletonPill w={72} h={28} />
      </div>
      <Skeleton className="sk-graph" style={{ display: 'block', marginTop: '12px', height: '260px', borderRadius: '12px' }} />
    </div>
  </div>
);

export const SkeletonDonutChartCard = () => (
  <div className="card custom-card overflow-hidden sk-card">
    <div className="card-body p-3">
      <Skeleton w="200px" h={16} />
      <Skeleton w="260px" h={12} style={{ marginTop: '8px', marginBottom: '12px' }} />
      <div className="d-flex align-items-center">
        <div style={{ flex: 1 }} className="d-flex justify-content-center">
          <SkeletonDonut size={180} />
        </div>
        <div className="ml-4" style={{ flexShrink: 0 }}>
          {[...Array(4)].map((_, i) => (
            <div key={i} className="d-flex align-items-center mb-2">
              <SkeletonCircle size={12} />
              <Skeleton w="140px" h={12} style={{ marginLeft: '8px' }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);
